jQuery(document).ready(function ($) {
  jQuery("#header-hamburguer").on("click", function () {
    if (jQuery(window).width() < 992) {
      jQuery("#header-mobile-menu").toggleClass("active");
    } else {
      jQuery("#header-desktop-menu .categories-menu-nav").toggleClass("active");
    }
  });

  jQuery("#close-menu-mobile").on("click", function () {
    jQuery("#header-mobile-menu").toggleClass("active");
  });

  jQuery(".menu-list .menu-item-has-children").on("click", function () {
    jQuery(this).find(".sub-menu").toggleClass("active");
  });

  jQuery(".categories-menu-list .menu-item-has-children").on(
    "click",
    function (ev) {
      ev.stopPropagation();
      jQuery(this).find(".sub-menu").toggleClass("active");
    }
  );

  jQuery("#header-desktop-menu .todos-os-produtos .menu-item-has-children").on(
    "mouseover",
    function (event) {
      var menuElement = jQuery(this);
      var menuSelect = menuElement
        .find(".categories-menu-item-name")
        .html()
        .replace(/[^a-zA-Z]/g, "")
        .replace(/\s/g, "")
        .toLowerCase();

      jQuery(
        "#header-desktop-menu .todos-os-produtos .subcategory-menu-nav." +
          menuSelect
      ).addClass("active 1");
      jQuery(
        "#header-desktop-menu .todos-os-produtos .subcategory-menu-nav"
      ).on("mouseover", () => {
        jQuery(
          "#header-desktop-menu .todos-os-produtos .subcategory-menu-nav." +
            menuSelect
        ).addClass("active");
        return;
      });
    }
  );

  jQuery(
    "#header-desktop-menu .todos-os-produtos .categories-menu-container"
  ).on("mouseleave", () => {
    jQuery(
      "#header-desktop-menu .todos-os-produtos .subcategory-menu-nav"
    ).removeClass("active");
  });

  jQuery("#header-desktop-menu .todos-os-produtos .categories-menu-item").on(
    "mouseover",
    function () {
      var menuSelect = jQuery(this)
        .find(".categories-menu-item-name")
        .html()
        .replace(/[^a-zA-Z]/g, "")
        .replace(/\s/g, "")
        .toLowerCase();
      var a = jQuery(
        "#header-desktop-menu .todos-os-produtos .subcategory-menu-nav"
      ).removeClass("active");

      var b = jQuery(
        "#header-desktop-menu .todos-os-produtos .subcategory-menu-nav." +
          menuSelect
      ).addClass("active");
    }
  );

  // let menuItens = document.querySelectorAll(".categories-menu-item-link");
  // menuItens.forEach((menuItem) => {
  //   let contentMenu = menuItem.querySelector("categories-menu-item-name");
  //   let data = menuItem.getAttribute("data-tracking-data");
  //   if (data == '{"category": "Kit Festa"}') {
  //     menuItem.setAttribute("href", "https://www.searakitfesta.com.br/");
  //   }
  // });

  // jQuery("#header-desktop-menu .todos-os-produtos .categories-menu-item")
  // .not(".aves")
  // .on("mouseover", () => {
  //   jQuery(
  //     "#header-desktop-menu .todos-os-produtos .subcategory-menu-nav"
  //   ).removeClass("active");
  // });

  /* Troca de logo Gourmet */
  const trocaLogoGourmet = () => {
    const headerLogo = jQuery('.main-header-logo');
    const logoGourmet = '<img src="https://www.seara.com.br/wp-content/themes/seara/library/images/main/logo_seara_gourmet_branca.png" data-adaptive="false" data-src="https://www.seara.com.br/wp-content/themes/seara/library/images/main/logo_seara_gourmet_branca.png" srcset="" width="25px" alt="Seara Gourmet" class="ic-fade-in wps-ic-loaded">';
    const currentUrl = window.location.href;
    let isSearch = window.location.href.includes("?s=");
    let is404 = jQuery("body").hasClass("error404");
    if (
      currentUrl.includes("gourmet") && 
      !isSearch && 
      !is404
    ) {
      headerLogo.html(logoGourmet);
    }

    if (
      jQuery("body").hasClass("seara-gourmet") &&
      !isSearch && 
      !is404
    ) {
      headerLogo.html(logoGourmet);
    }

    if (
      jQuery("body").hasClass("category-seara-gourmet") &&
      !isSearch && 
      !is404
    ) {
      headerLogo.html(logoGourmet);
    }
  };

  trocaLogoGourmet();


  /************************************
  Search Overlay
  ************************************/
  jQuery("#input-search").on("click", () => {
    jQuery(".header-search-overlay").addClass("active");
    jQuery(".header-search-modal").addClass("active");
  });

  jQuery(document).on("click", (ev) => {
    if (
      jQuery(ev.target).hasClass("close-search") ||
      jQuery(ev.target).hasClass("header-search-overlay")
    ) {
      jQuery(".header-search-overlay").removeClass("active");
      jQuery(".header-search-modal").removeClass(["active", "wrapped"]);
      jQuery("#input-search").val("");
      jQuery("#search-results").html("");
    }
  });

  jQuery(document).on("submit", "#header-search-bar form", function () {
    if (!dataLayer) return;

    dataLayer.push({
      event: "header-search-bar",
      siteSearchTerm: jQuery('#header-search-bar input[name="s"]').val(),
    });
  });


  /************************************
  Autocomplete search
  ************************************/
  function debounce(func, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  const getTerms = debounce(() => search_fetch(), 150);

  jQuery("#input-search").on("keyup", () => {
    if (jQuery("#input-search").val().length >= 3) {
      getTerms();
    } else {
      jQuery("#search-results").html("");
      jQuery(".header-search-modal").removeClass("wrapped");
    }
  });
});

// function linkExterno() {
//   let menuKit = document.querySelector(
//     ".menu-item.show-in-menu-mobile.kit-festa a"
//   );
//   menuKit.setAttribute("target", "_blank");
// }
// function linkExterno() {
//   let menuKit = document.querySelector(
//     ".menu-item.show-in-menu-mobile.kit-festa a"
//   );
//   menuKit.setAttribute("target", "_blank");
// }

/**Ativação de funções após o carregamento total da página */
// document.addEventListener("DOMContentLoaded", function () {
//   linkExterno();
// });
